module.exports = __webpack_public_path__ + "static/ribbon-6251ce4affc3df06d5070e2b052d4dd6.png";